import { CreditsResponse } from "../schema/usage";

export interface DiscountInfo {
	label: string;
	endDate: Date | null;
	endDateFormatted: string | null;
}

const formatDate = (date: Date) =>
	date.toLocaleDateString("de-DE", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});

/** Derives the active discount (coupon) display info from the raw Stripe subscription, if any. */
export const getDiscountInfo = (
	sub: CreditsResponse["stripeSubscription"]
): DiscountInfo | null => {
	if (!sub) {
		return null;
	}

	// Find the first expanded discount object (could be in discount or discounts array)
	const expandedDiscount =
		sub.discount && typeof sub.discount === "object" && sub.discount.id
			? sub.discount
			: Array.isArray(sub.discounts)
				? sub.discounts.find((d: unknown) => typeof d === "object" && d !== null && "id" in d)
				: null;

	if (!expandedDiscount) {
		return null;
	}

	// Discount end date
	const discountEnd = expandedDiscount.end ? new Date(expandedDiscount.end * 1000) : null;

	// Build discount label from source.coupon (coupon ID/name) or coupon object
	const couponId =
		typeof expandedDiscount.source?.coupon === "string" ? expandedDiscount.source.coupon : null;
	const couponObj = typeof expandedDiscount.coupon === "object" ? expandedDiscount.coupon : null;
	const couponName = couponObj?.name || couponId || null;

	return {
		label: couponName || "Discount active",
		endDate: discountEnd,
		endDateFormatted: discountEnd ? formatDate(discountEnd) : null,
	};
};
